import { Component, OnInit } from '@angular/core';
import {GeneralService} from '../../../../service/general-service';
import {Constant} from '../../../../shared/constants/constant.class';
import {Router} from '@angular/router';
import {UserService} from '../../../../service/user-service';
import {NotificationService} from '../../../../service/notification.service';
import {AppConfigService} from '../../../../../app-config.service';

@Component({
  selector: 'app-doctor-master',
  templateUrl: './doctor-master.component.html',
  styleUrls: ['./doctor-master.component.scss']
})
export class DoctorMasterComponent implements OnInit {
  partnerInfo: any;
  messageError: any;
  isShowChangePassword = false; // Control the visibility of the popup
  passwordChange = {
    oldPassword: '',
    password: '',
    repeatPassword: ''
  };
  isShowReport = false;
  isShowMenuPrice = false;
  appName: any;
  constructor(
    private generalService: GeneralService,
    private userService: UserService,
    private route: Router,
    private notificationService: NotificationService,
    private configService: AppConfigService,
  ) {
    this.partnerInfo = {
      name: 'Phòng khám đa khoa INVIVO LAB'
    };
    this.appName = this.configService.getConfig().api.appName;
    this.appName = this.appName.replace('&nbsp;', ' ');
  }

  ngOnInit(): void {
    this.generalService.getMyPartnerInfo().subscribe(
      (res) => {
        if (res !== null) {
          console.log(res);
          this.partnerInfo = res;
          this.isShowMenuPrice = res.partnerDisplayPrices.length > 0;
        }
      },
      (error) => {
        console.error(error);
        this.logout();
      }
    );
  }
  logout() {
    const fcmToken = localStorage.getItem(Constant.FIREBASE_TOKEN);
    if (fcmToken) {
      this.generalService.deleteToken(fcmToken).subscribe({
        next: () => {
          localStorage.removeItem(Constant.FIREBASE_TOKEN);
          console.log('[FCM] Đã xóa token khỏi BE ✅');
        }
      });
    }

    localStorage.removeItem(Constant.TOKEN);
    localStorage.removeItem(Constant.USER_INFO);
    localStorage.removeItem(Constant.FIREBASE_TOKEN);
    this.route.navigate(['/admin-login']);
  }
  closePopupChangePassword() {
    this.isShowChangePassword = false;
    // Optionally reset the form
    this.passwordChange = { oldPassword: '', password: '', repeatPassword: '' };
  }

  onChangePasswordClick() {
    this.messageError = null;
    if (this.isPasswordValid()) {
      // Implement password change logic here
      console.log('Password change requested:', this.passwordChange);
      this.userService.changePassword(this.passwordChange).subscribe(
        (res) => {
          if (res.ret && res.ret[0].code !== 0){
            this.notificationService.showNotification(Constant.ERROR, res.ret[0].message);
            this.messageError = res.ret[0].message;
          } else {
            this.closePopupChangePassword();
            this.notificationService.showNotification(Constant.SUCCESS, 'Thay đổi mật khẩu thành công');
          }
        },
        (error) => {
        }
      );
    }
  }

  isPasswordValid(): boolean {
    return (
      this.passwordChange.oldPassword &&
      this.passwordChange.password &&
      this.passwordChange.repeatPassword &&
      this.passwordChange.password === this.passwordChange.repeatPassword
    );
  }
  showModalPassword() {
    this.isShowChangePassword = true;
  }

  closeModal() {

  }
}
